import { render, staticRenderFns } from "./MemberDataTable.vue?vue&type=template&id=5a04a345"
import script from "./MemberDataTable.vue?vue&type=script&lang=ts"
export * from "./MemberDataTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports